import script from "./ItemSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemSelector.vue?vue&type=script&setup=true&lang=js"

import "./ItemSelector.vue?vue&type=style&index=0&id=48421a8d&lang=scss"

const __exports__ = script;

export default __exports__